import { render } from "./FederationDetails.vue?vue&type=template&id=12e9b6d9&scoped=true"
import script from "./FederationDetails.vue?vue&type=script&lang=js"
export * from "./FederationDetails.vue?vue&type=script&lang=js"

import "./FederationDetails.vue?vue&type=style&index=0&id=12e9b6d9&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e9b6d9"]])

export default __exports__